import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {AppParametricSelector, makeMapStateToProps} from '../../helpers/reselectHelpers';
import {IntegrationTypeModel} from '../../models/api/integrationTypesModel';
import {SettingsAppsTabsEnum, SettingsAppsUrl} from '../../models/url/settingsUrlModel';
import {AppState} from '../../store/appState';
import {getCompanyUrl} from '../../store/data/company/companySelectors';
import {
  getIntegrationTypes,
  getIsIntegrationTypesLoading,
  makeGetIsIntegrationTypeEnabled,
} from '../../store/data/integrationTypes/integrationTypesSelectors';
import {SettingsAppsHeader} from './settingsAppsHeader';

/*
 * Props.
 */

interface SettingsAppsHeaderContainerProps {
  url: SettingsAppsUrl;
}

/*
 * Selectors.
 */

function getUrl(_state: AppState, props: SettingsAppsHeaderContainerProps) {
  return props.url;
}

export const getIntegrationTypeFromUrl = createSelector(
  [getIntegrationTypes, getUrl],
  (integrationTypes, url) => {
    // We will only look for the integration type when we are viewing a single
    // integration details.
    if (url.tabPage === SettingsAppsTabsEnum.DETAILS) {
      return integrationTypes[url.appId];
    }
    return undefined;
  },
);

function makeGetIntegrationTypeId(
  getIntegrationType: AppParametricSelector<any, IntegrationTypeModel | undefined>,
) {
  return createSelector([getIntegrationType], (integrationType) => integrationType?.id);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsAppsHeaderContainerProps>()(() => ({
  companyUrl: getCompanyUrl,
  integrationType: getIntegrationTypeFromUrl,
  isIntegrationTypesLoading: getIsIntegrationTypesLoading,
  isIntegrationTypeEnabled: makeGetIsIntegrationTypeEnabled(
    makeGetIntegrationTypeId(getIntegrationTypeFromUrl),
  ),
}));

export const SettingsAppsHeaderContainer = connect(mapStateToProps)(SettingsAppsHeader);
